import { Button } from "@provenleap/ui";
import { GridFour, Table } from "@phosphor-icons/react";

export type ClientViewMode = "grid" | "table";

interface ViewSwitcherProps {
  view: ClientViewMode;
  onViewChange: (view: ClientViewMode) => void;
}

export function ViewSwitcher({ view, onViewChange }: ViewSwitcherProps) {
  const nextView = view === "grid" ? "table" : "grid";
  const Icon = view === "grid" ? GridFour : Table;
  const label = view === "grid" ? "Grid" : "Table";

  return (
    <Button
      variant="outline"
      className="shrink-0 rounded-2xl text-[13px] shadow-xs cursor-pointer hover:bg-background hover:-translate-y-0.5 hover:shadow-sm transition-all"
      style={{ border: "0.5px solid var(--hairline)" }}
      onClick={() => onViewChange(nextView)}
      aria-label={`Switch to ${nextView} view`}
    >
      <Icon size={16} className="mr-1" />
      {label}
    </Button>
  );
}
